import exportFromJSON from 'export-from-json';

export const ExportToExcel = ({data, fileName}) => {
    const exportType = exportFromJSON.types.xls

    exportFromJSON({ data, fileName, exportType })
};